import { c as _c } from "react/compiler-runtime";
import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
interface PriceItem {
  amount: number;
  description: string;
  color: 'blue' | 'black';
}
interface PriceListProps {
  prices: PriceItem[];
  isBenefitOpen?: boolean;
  onBenefitToggle?: () => void;
}
const COLOR_MAP = {
  blue: 'text-Gray-550',
  black: 'text-Gray-900'
} as const;
export type { PriceItem };
export const PriceList = t0 => {
  const $ = _c(10);
  const {
    prices,
    isBenefitOpen,
    onBenefitToggle
  } = t0;
  let t1;
  if ($[0] !== isBenefitOpen || $[1] !== onBenefitToggle || $[2] !== prices) {
    let t2;
    if ($[4] !== isBenefitOpen || $[5] !== onBenefitToggle || $[6] !== prices.length) {
      t2 = (price, index) => <div key={index} className="flex items-center gap-8"><span className={cn(index === 0 && prices.length > 1 ? "font-700 typo-h5 mobile-tablet:typo-body3" : "font-800 typo-h4 mobile-tablet:text-Gray-black mobile-tablet:typo-h7", COLOR_MAP[price.color])}>{price.amount.toLocaleString()}원</span><span className={cn("font-700 typo-body4", index === 0 && prices.length > 1 ? "mobile-tablet:typo-caption2" : "mobile-tablet:typo-caption1", COLOR_MAP[price.color])}>{price.description}</span>{index === 1 && onBenefitToggle && <button type="button" onClick={onBenefitToggle} className="flex size-16 items-center justify-center"><SvgChevrondown className={cn("size-10 text-Gray-black transition-transform", isBenefitOpen && "rotate-180")} /></button>}</div>;
      $[4] = isBenefitOpen;
      $[5] = onBenefitToggle;
      $[6] = prices.length;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = prices.map(t2);
    $[0] = isBenefitOpen;
    $[1] = onBenefitToggle;
    $[2] = prices;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <div className="flex flex-col gap-4">{t1}</div>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};